// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1baea303","732":"589e10b3","977":"7a4523e2"}[chunkId] + ".chunk.js";
};